// extracted by mini-css-extract-plugin
export default {"plugin":"PluginList_plugin__YbuHj"};